<template>
  <div class="tab-content" v-show="isSelected">
    <slot v-if="isShownFirstTime"></slot>
  </div>
</template>


<script>
export default {
  name: "Tab",
  props: {
    title: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    isSelected: false,
    isShownFirstTime: false,
    el: this,
  }),
  watch: {
    isSelected() {
      if (this.isSelected) this.isShownFirstTime = true;
    },
  },
  computed: {
		isMounted () {
			return false
		}
  },
  methods: {},
  mounted() {
  },
};
</script>

<style lang="scss">
.tab-content{
	width: 100%;
}
</style>
